import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// 수익화 및 그룹 관리를 위한 전역 상태 뼈대
export const useUserStore = create(
  persist(
    (set) => ({
      // 프리미엄 (유료 결제) 여부
      isPremium: false,
      
      // 현재 생성/가입된 그룹 리스트 (최대 3개)
      groups: [
        { id: 1, name: '기본 그룹' }
      ],

      // 프리미엄 구매 액션
      purchasePremium: () => set({ isPremium: true }),

      // 그룹 추가 (최대 3개)
      addGroup: (groupName) => set((state) => {
        if (state.groups.length >= 3) return state; // 최대 3개 제한
        return {
          groups: [...state.groups, { id: Date.now(), name: groupName }]
        };
      })
    }),
    {
      name: 'ansim-user-storage', // localStorage에 저장될 키 이름
      storage: createJSONStorage(() => localStorage), // 기본값이 localStorage이지만 명시적으로 지정
    }
  )
);
